import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import moment from 'moment';
import { BaseDialogComponent } from '../base-dialog/base-dialog.component';
import { LoggerService } from '../../../services/logger.service';

@Component({
  selector: 'app-cancel-future-appointment',
  templateUrl: './cancel-future-appointment.component.html',
  styleUrls: ['./cancel-future-appointment.component.css']
})
export class CancelFutureAppointmentComponent extends BaseDialogComponent implements OnInit {
  override entityId = this._injectedDialogData['data']['EntityID'];
  lessonsToDelete: any[] = [];

  get dialogTitle(): string {
    const bundle = this._injectedDialogData?.['data']?.['bundle'];
    switch (bundle) {
      case 'lesson': return 'Delete Future Lessons';
      case 'schedules': return 'Delete Future Schedules';
      case 'services': return 'Cancel Future Services';
      case 'group_lesson': return 'Delete Future Group Lessons';
      default: return 'Delete Future Appointments';
    }
  }

  override ngOnInit(): void {
    this.getLessonsToDelete();
  }

  getLessonsToDelete() {
    LoggerService.log('CancelFutureAppointmentComponent - getLessonsToDelete');
    this.displayProgressSpinner(true);

    let params: any = {
      eventID: this._injectedDialogData?.['data']?.['entityID'],
      field_studio_reference: this._injectedDialogData?.['data']?.['field_studio_reference'],
      bundle: this._injectedDialogData?.['data']?.['bundle']
    };

    if (this.bundle !== 'services') {
      params.parentID = this._injectedDialogData?.['data']?.['parentID'];
    }

    LoggerService.log('API request params:', params);

    this._drupalRESTService.httpPOST('/api_rest/v1/cancelFutureStandingAppts', params)
      .subscribe(data => {
        this.displayProgressSpinner(false);
        LoggerService.log('API response data:', data);
        if (data?.['lesson_to_delete']) {
          this.lessonsToDelete = data['lesson_to_delete'];
          LoggerService.log('Lessons to delete:', this.lessonsToDelete);
        } else if (data?.['services_to_delete']) {
          this.lessonsToDelete = data['services_to_delete'];
          LoggerService.log('Services to delete:', this.lessonsToDelete);
        } else if (data?.['schedules_to_delete']) {
          this.lessonsToDelete = data['schedules_to_delete'];
          LoggerService.log('Schedules to delete:', this.lessonsToDelete);
        } else if (data?.['group_lesson_to_delete']) {
          this.lessonsToDelete = data['group_lesson_to_delete'];
          LoggerService.log('Group lessons to delete:', this.lessonsToDelete);
        }
        if (data?.['message']) {
          this.errorMessage = data['message'];
          LoggerService.log('Error message:', this.errorMessage);
        }
      },
        error => {
          this.displayProgressSpinner(false);
          this.errorMessage = "There was a problem retrieving future appointments.";
          LoggerService.error('API error:', error);
          this.handleError(error);
        });
  }

  override onSubmit(form: NgForm) {
    LoggerService.log('CancelFutureAppointmentComponent - onSubmit');
    this.displayProgressSpinner(true);

    let params: any = {
      parentID: this._injectedDialogData?.['data']?.['parentID'],
      eventID: this._injectedDialogData?.['data']?.['entityID'],
      field_studio_reference: this._injectedDialogData?.['data']?.['field_studio_reference'],
      bundle: this._injectedDialogData?.['data']?.['bundle'],
      confirm: true
    };
    LoggerService.log('API request params:', params);

    this._drupalRESTService.httpPOST('/api_rest/v1/cancelFutureStandingAppts', params)
      .subscribe(data => {
        this.displayProgressSpinner(false);
        LoggerService.log('API response data:', data);
        if (data?.['success']) {
          LoggerService.log('Success message:', data['success']);
          this._dialog.closeAll();
        }
        if (data?.['message']) {
          this.errorMessage = data['message'];
          LoggerService.log('Error message:', this.errorMessage);
        }
      },
        error => {
          this.displayProgressSpinner(false);
          this.errorMessage = "There was a problem canceling future lessons.";
          LoggerService.error('API error:', error);
          this.handleError(error);
        });
  }

  onCancel() {
    LoggerService.log('CancelFutureAppointmentComponent - onCancel');
    this._dialog.closeAll();
  }
}
